import { SITE_URL, SUPPORT_EMAIL } from '../../config';

export const inclusions = [
  'The price shown covers all services in the quote.',
  'Includes travel if you have requested a mobile service. No travel charges on the day.',
  'Parking is not included for mobile services, please arrange parking or reimburse the provider on the day',
];

export const defaultFaqs = [
  {
    q: `Can I pick the stylist?`,
    a: `Yes, of course. You can pick the stylist that best suits you.`,
  },

  {
    q: `Does it include lashes?`,
    a: `If you're getting makeup done, the price includes lashes.`,
  },

  {
    q: `Does it include travel?`,
    a: `Yes, the price is inclusive of travel if you have requested a mobile service. If the stylist needs parking, please either arrange parking for the stylist or reimburse the stylist for any parking expenses on the day.`,
  },

  {
    q: `Does the stylist come to me?`,
    a: `Yes, the stylist will come to you if you have requested a mobile service.`,
  },

  {
    q: `How can I book this offer?`,
    a: `Click on the 'Check Availability' button above to request an appointment with this stylist. Your request will be sent to the stylist and if the stylist is available, you will receive a start and end time for the appointment. If you are happy with the appointment time, you can click on the “Book Now” button to book in the stylist.`,
  },

  {
    q: `How can I read the review?`,
    a: `The reviews are all located under the tab "Reviews" above.`,
  },

  {
    q: `How do I arrange a trial?`,
    a: `If you would like to arrange a paid trial, please book in the date that you actually require the stylist e.g. on your wedding date. After the wedding date is secure, we can then arrange a paid trial for you. Please send us an email to hey@flayr.life with your ideal date for a trial.`,
  },

  {
    q: `I inserted the wrong details.`,
    a: `No problem, you can just grab another quote on our website -> <a href="${SITE_URL}" target="__blank" class="text-primary underline">${SITE_URL}</a>  `,
  },

  {
    q: `I want to add another person.`,
    a: `You can just grab another quote on our website -> <a href="${SITE_URL}" target="__blank" class="text-primary underline">${SITE_URL}</a>  `,
  },

  {
    q: `I want to change the location`,
    a: `No problem, you can just grab another quote on our website -> <a href="${SITE_URL}" target="__blank" class="text-primary underline">${SITE_URL}</a>  `,
  },

  {
    q: `I want to change the package?`,
    a: `Easiest way is just to grab another quote on our website -> <a href="${SITE_URL}" target="__blank" class="text-primary underline">${SITE_URL}</a>  `,
  },

  {
    q: `I want to remove a person.`,
    a: `You can just grab another quote on our website -> <a href="${SITE_URL}" target="__blank" class="text-primary underline">${SITE_URL}</a>  `,
  },

  {
    q: `Is hair styled wet or dry?`,
    a: `Your hair is usually styled dry by the stylist, so please wash and dry your hair and the stylist will then style it for you.`,
  },

  {
    q: `Is this price per person?`,
    a: `No. This quote estimate is for everyone in the quote under ‘Offer Details' above.`,
  },

  {
    q: `What makeup brands are used?`,
    a: `The stylist's makeup brands used on the day of the appointment are listed in the tab titled "My Kit" above.`,
  },

  {
    q: `What's included in this price?`,
    a: `If you click on ‘Offer Details' above, you can see what is included for the price quoted by the stylist. The price shown covers everyone in the quote, including makeup supplies if your quote includes makeup. Parking is not included, so please arrange parking or reimburse the stylist on the day for the parking expenses.`,
  },

  {
    q: `Is parking included in the price?`,
    a: `No, so please arrange for parking or reimburse the stylist on the day for the parking expenses.`,
  },
];

export const requestedFaqs = [
  {
    q: `Can I pick the stylist?`,
    a: `Yes, of course. You can pick the stylist that best suits you.`,
  },

  {
    q: `Does it include lashes?`,
    a: `If you're getting makeup done, the price includes lashes.`,
  },

  {
    q: `Does it include travel?`,
    a: `Yes, the price is inclusive of travel if you have requested a mobile service. If the stylist needs parking, please either arrange parking for the stylist or reimburse the stylist for any parking expenses on the day.`,
  },

  {
    q: `Does the stylist come to me?`,
    a: `Yes, the stylist will come to you if you have requested a mobile service.`,
  },

  {
    q: `How can I book this offer?`,
    a: `We are checking with the stylist if they are available for your appointment request. We will text and email you as soon as the stylist responds. If the stylist is available, you will receive a link to book the appointment. `,
  },

  {
    q: `How can I read the reviews?`,
    a: `The reviews are all located under the tab "Reviews" above.`,
  },

  {
    q: `How do I arrange a trial?`,
    a: `If you would like to arrange a paid trial, please book in the date that you actually require the stylist e.g. on your wedding date. After the wedding date is secure, we can then arrange a paid trial for you. Please send us an email to hey@flayr.life with your ideal date for a trial`,
  },

  {
    q: `How long does a stylist take to respond to my appointment request?`,
    a: `They are usually fairly quick, but if you don’t get a response within 4 hours, please email us at hey@flayr.life and we can chase up the stylist for you. `,
  },

  {
    q: `I inserted the wrong details.`,
    a: `No problem, you can just grab another quote on our website -> <a href="${SITE_URL}" target="__blank" class="text-primary underline">${SITE_URL}</a> `,
  },

  {
    q: `I want to add another person.`,
    a: `You can just grab another quote on our website -> <a href="${SITE_URL}" target="__blank" class="text-primary underline">${SITE_URL}</a> `,
  },

  {
    q: `I want to change the location`,
    a: `No problem, you can just grab another quote on our website -> <a href="${SITE_URL}" target="__blank" class="text-primary underline">${SITE_URL}</a> `,
  },

  {
    q: `I want to change the package?`,
    a: `Easiest way is just to grab another quote on our website -> <a href="${SITE_URL}" target="__blank" class="text-primary underline">${SITE_URL}</a>  `,
  },

  {
    q: `I want to remove a person.`,
    a: `You can just grab another quote on our website -> <a href="${SITE_URL}" target="__blank" class="text-primary underline">${SITE_URL}</a> `,
  },

  {
    q: `Is hair styled wet or dry?`,
    a: `Your hair is usually styled dry by the stylist, so please wash and dry your hair and the stylist will then style it for you.`,
  },

  {
    q: `Is parking included in the price?`,
    a: `No, so please arrange parking or reimburse the stylist on the day for the parking expenses.`,
  },

  {
    q: `Is this price per person?`,
    a: `No. This quote estimate is for everyone in the quote under the 'Offer Details' above.`,
  },

  {
    q: `What makeup brands are used?`,
    a: `The stylist's makeup brands are listed in the tab titled "My Kit" above.`,
  },

  {
    q: `What's included in this price?`,
    a: `If you click on 'Offer Details' above, you can see what is included for the price quoted by the stylist. The price shown covers everyone in the quote, including makeup supplies if your quote includes makeup. Parking is not included, so please arrange for parking or reimburse the stylist on the day for the parking expenses.`,
  },
];

export const offeredFaqs = [
  {
    q: `Can I pick the stylist?`,
    a: `Yes, of course. You can pick the stylist that best suits you.`,
  },

  {
    q: `Does it include lashes?`,
    a: `If you're getting makeup done, the price includes lashes.`,
  },

  {
    q: `Does it include travel?`,
    a: `Yes, the price is inclusive of travel if you have selected a mobile service. If the stylist needs parking, please either arrange parking for the stylist or reimburse the stylist for any parking expenses on the day.`,
  },

  {
    q: `Does the stylist come to me?`,
    a: `Yes, the stylist will come to you if you have selected a mobile service.`,
  },

  {
    q: `How can I book this offer?`,
    a: `Click on the 'Book Now' button above to book in this appointment with a deposit.`,
  },

  {
    q: `How can I read the review?`,
    a: `The reviews are all located under the tab "Reviews" above.`,
  },

  {
    q: `How do I arrange a trial?`,
    a: `If you would like to arrange a paid trial, please book in the date that you actually require the stylist e.g. on your wedding date. After the wedding date is secure, we can then arrange a paid trial for you. Please send us an email to hey@flayr.life with your ideal date for a trial`,
  },

  {
    q: `How do I request a new time`,
    a: `In the "Offer Details" tab, click on the "Request New Date/Time" button`,
  },

  {
    q: `I inserted the wrong details.`,
    a: `No problem, you can just grab another quote on our website -> <a href="${SITE_URL}" target="__blank" class="text-primary underline">${SITE_URL}</a>  `,
  },

  {
    q: `I need a different time.`,
    a: `No problem. You can click the 'Request New Date/Time’' button in the 'Offer Details' section to request a new start time. If the stylist is available at the new start time, you will receive an email with the new start and end times.`,
  },

  {
    q: `I want to add another person.`,
    a: `You can just grab another quote on our website -> <a href="${SITE_URL}" target="__blank" class="text-primary underline">${SITE_URL}</a>  `,
  },

  {
    q: `I want to change the location`,
    a: `No problem, you can just grab another quote on our website -> <a href="${SITE_URL}" target="__blank" class="text-primary underline">${SITE_URL}</a>  `,
  },

  {
    q: `I want to change the package?`,
    a: `Easiest way is just to grab another quote on our website -> <a href="${SITE_URL}" target="__blank" class="text-primary underline">${SITE_URL}</a>  `,
  },

  {
    q: `I want to remove a person.`,
    a: `You can just grab another quote on our website -> <a href="${SITE_URL}" target="__blank" class="text-primary underline">${SITE_URL}</a>  `,
  },

  {
    q: `Is hair styled wet or dry?`,
    a: `Your hair is usually styled dry by the stylist, so please wash and dry your hair and the stylist will then style it for you.`,
  },

  {
    q: `Is parking included in the price?`,
    a: `No, so please arrange for parking or reimburse the stylist on the day for the parking expenses.`,
  },

  {
    q: `Is this price per person?`,
    a: `No. This quote estimate is for everyone in the quote under ‘Offer Details' above.`,
  },

  {
    q: `What makeup brands are used?`,
    a: `The stylist's makeup brands are listed in the tab titled "My Kit" above.`,
  },

  {
    q: `What's included in this price?`,
    a: `If you click on 'Offer Details' above, you can see what is included for the price quoted by the stylist. The price shown covers everyone in the quote, including makeup supplies if your quote includes makeup. Parking is not included, so please arrange for parking or reimburse the stylist on the day for parking expenses.`,
  },

  {
    q: `What is your cancellation policy?`,
    a: `We have a Covid Cancellation policy which is set out below: <br /> We know plans can change rapidly, so give at least 1 day’s notice and get a full credit for the deposit paid that is valid for 6 months and can be used to pay the deposit on any future bookings.`,
  },
];

export const bookedFaqs = [
  {
    q: `How can I add people?`,
    a: `You can click on “Change” to add more people to the booking`,
  },

  {
    q: `How can I contact the stylist?`,
    a: `You can contact the stylist by clicking on “Contact Stylist” (on desktop) or the Chat bubble (on mobile). You can also log into your dashboard on -> https://app.flayr.life/login `,
  },

  {
    q: `How do I cancel the booking?`,
    a: `You can cancel the booking by clicking on “Cancel”.`,
  },

  {
    q: `How do I change the location?`,
    a: `If you change the location, the stylist reserves the right to cancel the booking. Please contact the stylist to see if they are able to accommodate the change in location. The deposit and service fee is non-refundable.`,
  },

  {
    q: `How do I change the time?`,
    a: `The stylist has booked you in for a certain time slot as per the booking confirmation email. If you need to change the time, please click on “Reschedule” and you can click on “Time” to request a change of time. If the stylist is able to accommodate the time change, you will get a new appointment time slot that you can book in. `,
  },

  {
    q: `How do I pay the stylist?`,
    a: `Please contact the stylist directly to discuss which payment method the stylist prefers (e.g. cash, EFT or credit card transaction). You can contact the stylist by clicking on “Contact Stylist” (on desktop) or the Chat bubble (on mobile). You can also log into your dashboard on -> https://app.flayr.life/login `,
  },

  {
    q: `How do I reduce people?`,
    a: `If you reduce the number of people on the booking, the stylist reserves the right to cancel the booking. The deposit and service fee is non refundable. You can click on “Change” to send a request to the stylist to reduce the numbers for this booking. `,
  },

  {
    q: `How much does parking cost?`,
    a: `Parking is not included in the price above. Please arrange parking for the stylist or alternatively please reimburse the stylist for parking on the day of the appointment. Please contact the stylist to confirm the parking costs.`,
  },

  {
    q: `I haven’t been contacted by the stylist.`,
    a: `You can contact the stylist by clicking on “Contact Stylist” (on desktop) or the Chat bubble (on mobile). You can also log into your dashboard on -> https://app.flayr.life/login Please email hey@flayr.life if the stylist has not responded within 24 hours.`,
  },

  {
    q: `I don't have a booking confirmation email`,
    a: `Please check your junk email to make sure the booking confirmation email hasn’t gone into junk. Alternatively please email us at <a href="mailto:${SUPPORT_EMAIL}" class="text-primary underline" target="__blank">${SUPPORT_EMAIL}</a>`,
  },

  {
    q: `Is hair styled wet or dry?`,
    a: `Your hair is usually styled dry by the stylist, so please wash and dry your hair and the stylist will then style it for you.`,
  },

  {
    q: `What is your cancellation policy?`,
    a: `We have a Covid Cancellation policy which is set out below: <br /> We know plans can change rapidly, so give at least 1 day’s notice and get a full credit for the deposit paid that is valid for 6 months and can be used to pay the deposit on any future bookings.`,
  },
];
